/**
 * Single home for the impersonation-session predicate
 * (docs/users-rbac-implementation-brief.md, Stage 6).
 *
 * The admin worker hands off an opaque `imp_*` token via the URL fragment;
 * main.jsx captures it into sessionStorage BEFORE MSAL initializes. Every
 * consumer that needs "is this an impersonation session?" must use this
 * helper — the PermissionContext zero-roles bug happened precisely because
 * the router and the token layer knew about impersonation while the
 * permission layer re-derived authentication from MSAL alone.
 */

export function getImpersonationToken() {
  if (typeof window === 'undefined') return null
  return window.sessionStorage?.getItem('impersonationToken') || null
}

export function hasImpersonationToken() {
  return getImpersonationToken() !== null
}
